// DAS-65 Phase 1 + DAS-70 Wave-A: VariantState 유틸리티
// localStorage 영속화 + DOM data-variant 속성 동기화를 담당한다.
// DAS-70: variant 매핑 확장 v1/v2 → v1/v2/v3
//   v1 = 기존(legacy) UI
//   v2 = IS 리프레시 (Wave-B/C 에서 실제 포팅, 현재는 슬롯만 준비)
//   v3 = 정보 구조 재설계 (기존 v2 디렉토리를 rename)

export const VARIANT_KEY = 'dashboard_variant';

export const VARIANTS = {
    v1: 'v1',
    v2: 'v2',
    v3: 'v3',
};

export const DEFAULT_VARIANT = 'v1';

// DAS-151: 버전을 v1으로 고정한다.
// 잠금 상태에서는 v2/v3 선택 토글이 숨겨지며, localStorage에 과거 v2/v3 값이
// 남아 있어도 항상 v1을 강제한다. v2/v3를 다시 노출하려면 false로 변경하고
// nav_bar.js의 VariantToggle 렌더를 복원하면 된다.
export const VERSION_LOCKED = true;

/**
 * localStorage에서 저장된 variant를 읽는다.
 * 유효하지 않은 값은 DEFAULT_VARIANT로 폴백.
 * VERSION_LOCKED가 true이면 저장값과 무관하게 항상 DEFAULT_VARIANT를 반환한다.
 */
export const getStoredVariant = () => {
    if (VERSION_LOCKED) {
        return DEFAULT_VARIANT;
    }
    try {
        const stored = window.localStorage.getItem(VARIANT_KEY);
        if (stored && Object.values(VARIANTS).includes(stored)) {
            return stored;
        }
    } catch (_) {
        // localStorage 접근 불가 환경(SSR 등)에서는 기본값 반환
    }
    return DEFAULT_VARIANT;
};

/**
 * localStorage에 variant를 저장한다. 유효값(v1/v2/v3)만 저장.
 * VERSION_LOCKED가 true이면 저장을 무시한다(v1 고정).
 */
export const setStoredVariant = (v) => {
    if (VERSION_LOCKED) return;
    if (!Object.values(VARIANTS).includes(v)) return;
    try {
        window.localStorage.setItem(VARIANT_KEY, v);
    } catch (_) {
        // 저장 실패 시 무시
    }
};

/**
 * document.documentElement에 data-variant 속성을 적용한다.
 */
export const applyVariant = (v) => {
    if (typeof document !== 'undefined') {
        document.documentElement.setAttribute('data-variant', v);
    }
};

/**
 * 앱 최초 마운트 시 1회 호출.
 * Phase 0.5 migration: dashboard_theme 키 잔재를 제거하고
 * 저장된 variant 값을 로드해 DOM에 반영한다.
 */
let _initialized = false;
export const initVariant = () => {
    if (_initialized) return;
    _initialized = true;

    // Phase 0.5 잔재 정리 (dashboard_theme 키가 남아 있으면 제거)
    try {
        window.localStorage.removeItem('dashboard_theme');
    } catch (_) {
        // 무시
    }

    const variant = getStoredVariant();
    applyVariant(variant);
    return variant;
};
